// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.login-page {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  background: var(--sap-canvas);
}

/* ---------------- Hero de marca ---------------- */
.login-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 56px 64px;
  color: #fff;
  background: linear-gradient(135deg, var(--sap-primary) 0%, var(--sap-primary-strong) 100%);
}

.login-hero__content {
  position: relative;
  z-index: 1;
  max-width: 460px;
}

.login-hero__logo {
  height: 54px;
  margin-bottom: 32px;
  filter: brightness(0) invert(1); /* logo en blanco sobre el azul */
}

.login-hero__title {
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.1;
  margin: 0 0 10px;
}

.login-hero__subtitle {
  font-size: 18px;
  font-weight: 600;
  opacity: 0.95;
  margin: 0 0 22px;
}

.login-hero__desc {
  font-size: 15px;
  line-height: 1.65;
  opacity: 0.82;
  margin: 0;
}

.login-hero__glow {
  position: absolute;
  width: 520px;
  height: 520px;
  right: -180px;
  bottom: -200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.16), transparent 62%);
  pointer-events: none;
}

.login-hero__glow--sm {
  width: 280px;
  height: 280px;
  right: auto;
  bottom: auto;
  left: -120px;
  top: -100px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.12), transparent 62%);
}

/* ---------------- Panel de acceso ---------------- */
.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  padding: 40px 34px;
  background: var(--sap-surface);
  border: 1px solid var(--sap-border);
  border-radius: var(--sap-radius-lg);
  box-shadow: var(--sap-shadow-2);
}

.login-card__logo {
  height: 46px;
  align-self: center;
  margin-bottom: 22px;
}

.login-card__title {
  margin: 0 0 4px;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: var(--sap-text);
}

.login-card__hint {
  margin: 0 0 26px;
  font-size: 14px;
  text-align: center;
  color: var(--sap-text-muted);
}

.login-card__submit {
  height: 46px;
  margin-top: 6px;
  font-weight: 600;
  font-size: 15px;
}

.login-card__progress {
  margin-top: 12px;
}

.login-card__footer {
  margin: 22px 0 0;
  font-size: 12px;
  text-align: center;
  color: var(--sap-text-faint);
}

/* ---------------- Responsive ---------------- */
@media (max-width: 900px) {
  .login-page {
    grid-template-columns: 1fr;
  }
  .login-hero {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/routes/pages/login/login.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;AAER;;AAAA;EACE,iBAAA;EACA,aAAA;EACA,iCAAA;EACA,6BAAA;AAGF;;AAAA,oDAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0FAAA;AAGF;;AAAA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AAGF;;AAAA;EACE,YAAA;EACA,mBAAA;EACA,+BAAA,EAAA,iCAAA;AAGF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAGF;;AAAA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AAGF;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,+EAAA;EACA,oBAAA;AAGF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,+EAAA;AAGF;;AAAA,sDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mCAAA;EACA,mCAAA;EACA,+BAAA;AAGF;;AAAA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAGF;;AAAA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAGF;;AAAA,iDAAA;AACA;EACE;IAAc,0BAAA;EAId;EAHA;IAAc,aAAA;EAMd;AACF","sourcesContent":[":host { display: block; }\n\n.login-page {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 1.05fr 1fr;\n  background: var(--sap-canvas);\n}\n\n/* ---------------- Hero de marca ---------------- */\n.login-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  padding: 56px 64px;\n  color: #fff;\n  background: linear-gradient(135deg, var(--sap-primary) 0%, var(--sap-primary-strong) 100%);\n}\n\n.login-hero__content {\n  position: relative;\n  z-index: 1;\n  max-width: 460px;\n}\n\n.login-hero__logo {\n  height: 54px;\n  margin-bottom: 32px;\n  filter: brightness(0) invert(1);   /* logo en blanco sobre el azul */\n}\n\n.login-hero__title {\n  font-size: 42px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  margin: 0 0 10px;\n}\n\n.login-hero__subtitle {\n  font-size: 18px;\n  font-weight: 600;\n  opacity: .95;\n  margin: 0 0 22px;\n}\n\n.login-hero__desc {\n  font-size: 15px;\n  line-height: 1.65;\n  opacity: .82;\n  margin: 0;\n}\n\n.login-hero__glow {\n  position: absolute;\n  width: 520px;\n  height: 520px;\n  right: -180px;\n  bottom: -200px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 255, 255, .16), transparent 62%);\n  pointer-events: none;\n}\n\n.login-hero__glow--sm {\n  width: 280px;\n  height: 280px;\n  right: auto;\n  bottom: auto;\n  left: -120px;\n  top: -100px;\n  background: radial-gradient(circle, rgba(255, 255, 255, .12), transparent 62%);\n}\n\n/* ---------------- Panel de acceso ---------------- */\n.login-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 34px;\n  background: var(--sap-surface);\n  border: 1px solid var(--sap-border);\n  border-radius: var(--sap-radius-lg);\n  box-shadow: var(--sap-shadow-2);\n}\n\n.login-card__logo {\n  height: 46px;\n  align-self: center;\n  margin-bottom: 22px;\n}\n\n.login-card__title {\n  margin: 0 0 4px;\n  font-size: 22px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--sap-text);\n}\n\n.login-card__hint {\n  margin: 0 0 26px;\n  font-size: 14px;\n  text-align: center;\n  color: var(--sap-text-muted);\n}\n\n.login-card__submit {\n  height: 46px;\n  margin-top: 6px;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.login-card__progress {\n  margin-top: 12px;\n}\n\n.login-card__footer {\n  margin: 22px 0 0;\n  font-size: 12px;\n  text-align: center;\n  color: var(--sap-text-faint);\n}\n\n/* ---------------- Responsive ---------------- */\n@media (max-width: 900px) {\n  .login-page { grid-template-columns: 1fr; }\n  .login-hero { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
